// @ts-nocheck
import { CASE_COMMENTS_ADD_ERROR, CASE_COMMENTS_ADD_LOADING, CASE_COMMENTS_ADD_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseCommentsAddReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_COMMENTS_ADD_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_COMMENTS_ADD_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_COMMENTS_ADD_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

